module.exports = __webpack_public_path__ + "img/Good-Samaritan-Acts.6487a4bd.png";